import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

/**
 * Storage for large values that don't need to sit in WebKit's ~5 MB localStorage quota.
 * On the phone it uses native app storage (@capacitor/preferences); on the web it stays in localStorage.
 */
export const bulkStore = {
  isNative(): boolean {
    return Capacitor.isNativePlatform();
  },

  async get(key: string): Promise<string | null> {
    if (!Capacitor.isNativePlatform()) return localStorage.getItem(key);
    return (await Preferences.get({ key })).value ?? null;
  },

  /** Writes the value and reads it back. Returns true only if the stored copy matches exactly. */
  async setVerified(key: string, value: string): Promise<boolean> {
    try {
      if (!Capacitor.isNativePlatform()) {
        localStorage.setItem(key, value);
        return localStorage.getItem(key) === value;
      }
      await Preferences.set({ key, value });
      return (await Preferences.get({ key })).value === value;
    } catch (e) {
      console.error(`Failed to write ${key}`, e);
      return false;
    }
  },

  async remove(key: string): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      localStorage.removeItem(key);
      return;
    }
    await Preferences.remove({ key });
  },
};
